module.exports = require("lodash/remove");